import _styled from '@emotion/styled/base';
import 'react';
import { FONT_STYLE } from '@bucketplace/design-system';
import { jsx } from '@emotion/react';

function HeaderButton(props) {
  var className = props.className,
    isActive = props.isActive,
    onClick = props.onClick,
    children = props.children;
  return jsx(StyledHeaderButton, {
    type: "button",
    className: className,
    onClick: onClick,
    "aria-pressed": isActive,
    isActive: isActive
  }, children);
}
var StyledHeaderButton = /*#__PURE__*/_styled("button", process.env.NODE_ENV === "production" ? {
  target: "emy1t7u0"
} : {
  target: "emy1t7u0",
  label: "StyledHeaderButton"
})("height:100%;", FONT_STYLE.detail12L16, ";color:", function (_ref) {
  var theme = _ref.theme;
  return theme.base.neutral0;
}, ";padding:3px 6px 4px;margin:-4px 0 -5px;cursor:pointer;border-radius:4px;&:hover{background-color:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.base.neutral500;
}, ";}", function (_ref3) {
  var isActive = _ref3.isActive,
    theme = _ref3.theme;
  return isActive && "\n    background-color: ".concat(theme.base.neutral500, ";\n  ");
}, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkhlYWRlckJ1dHRvbi50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBMEJnRSIsImZpbGUiOiJIZWFkZXJCdXR0b24udHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCB7IEZPTlRfU1RZTEUgfSBmcm9tICdAYnVja2V0cGxhY2UvZGVzaWduLXN5c3RlbSc7XG5cbmV4cG9ydCBpbnRlcmZhY2UgSGVhZGVyQnV0dG9uUHJvcHMge1xuICBjbGFzc05hbWU/OiBzdHJpbmc7XG4gIGlzQWN0aXZlPzogYm9vbGVhbjtcbiAgb25DbGljaz86ICgpID0+IHZvaWQ7XG4gIGNoaWxkcmVuOiBSZWFjdC5SZWFjdE5vZGU7XG59XG5cbmV4cG9ydCBmdW5jdGlvbiBIZWFkZXJCdXR0b24ocHJvcHM6IEhlYWRlckJ1dHRvblByb3BzKTogUmVhY3QuUmVhY3RFbGVtZW50IHtcbiAgY29uc3QgeyBjbGFzc05hbWUsIGlzQWN0aXZlLCBvbkNsaWNrLCBjaGlsZHJlbiB9ID0gcHJvcHM7XG4gIHJldHVybiAoXG4gICAgPFN0eWxlZEhlYWRlckJ1dHRvblxuICAgICAgdHlwZT1cImJ1dHRvblwiXG4gICAgICBjbGFzc05hbWU9e2NsYXNzTmFtZX1cbiAgICAgIG9uQ2xpY2s9e29uQ2xpY2t9XG4gICAgICBhcmlhLXByZXNzZWQ9e2lzQWN0aXZlfVxuICAgICAgaXNBY3RpdmU9e2lzQWN0aXZlfVxuICAgID5cbiAgICAgIHsgY2hpbGRyZW4gfVxuICAgIDwvU3R5bGVkSGVhZGVyQnV0dG9uPlxuICApO1xufVxuXG5jb25zdCBTdHlsZWRIZWFkZXJCdXR0b24gPSBzdHlsZWQuYnV0dG9uPHsgaXNBY3RpdmU/OiBib29sZWFuIH0+YFxuICBoZWlnaHQ6IDEwMCU7XG4gICR7Rk9OVF9TVFlMRS5kZXRhaWwxMkwxNn07XG4gIGNvbG9yOiAkeyh7IHRoZW1lIH0pID0+IHRoZW1lLmJhc2UubmV1dHJhbDB9O1xuICBwYWRkaW5nOiAzcHggNnB4IDRweDtcbiAgbWFyZ2luOiAtNHB4IDAgLTVweDtcbiAgY3Vyc29yOiBwb2ludGVyO1xuICBib3JkZXItcmFkaXVzOiA0cHg7XG5cbiAgJjpob3ZlciB7XG4gICAgYmFja2dyb3VuZC1jb2xvcjogJHsoeyB0aGVtZSB9KSA9PiB0aGVtZS5iYXNlLm5ldXRyYWw1MDB9O1xuICB9XG5cbiAgJHsoeyBpc0FjdGl2ZSwgdGhlbWUgfSkgPT4gaXNBY3RpdmUgJiYgYFxuICAgIGJhY2tncm91bmQtY29sb3I6ICR7dGhlbWUuYmFzZS5uZXV0cmFsNTAwfTtcbiAgYH1cbmA7XG4iXX0= */"));

export { HeaderButton };
//# sourceMappingURL=HeaderButton.js.map
